module.exports = __webpack_public_path__ + "c9b396c5fed8fd67e422a0832e113bdd.png";